import { Card, Dropdown, FloatButton, Tooltip } from 'antd'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import AddNewAbonementServices from '../Modals/AddNewAbonementServices';
import EditNewAbonementServices from '../Modals/EditNewAbonementServices';
import SureModal from 'src/components/Modals/SureModal';
import { deleteClubItem, getAbonementListClubItems, getServices } from 'src/store/Slices/AbonementsSlice';
import { useEffect } from 'react';
import { openNotification } from 'src/components/helpers/notification';

const MobileAbonementsSostav = ({
    abonementClubsItems,
    abonementClubsItemsLoading,
    abonementCostInfo,
    abonementSostavInfo,
    setAbonementSostavInfo,
    mnemo
}) => {

    const dispatch = useDispatch()
    const items = [
        {
            key: '1',
            label: 'Редактировать',
            onClick: () => { setIsOpenEditServices(true) },
            disabled: (!mnemo?.children?.find(el => el.name === 'Состав пакета')?.children.find(ele => ele.mnemo === 'updateBtn'))
        },
        {
            key: '2',
            label: 'Удалить',
            onClick: () => { setIsOpenDeleteModal(true) },
            disabled: (!mnemo?.children?.find(el => el.name === 'Состав пакета')?.children.find(ele => ele.mnemo === 'deleteBtn'))
        },
    ];

    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
    const [isOpenEditServices, setIsOpenEditServices] = useState(false)
    const [isOpenModalServ, setIsOpenModalServ] = useState(false)

    const onClickDelete = () => {
        dispatch(deleteClubItem({
            clubItemId: abonementSostavInfo.id
        })).then(() => {
            openNotification({
                type: 'success',
                message: `Состав пакета успешно удален`
            })
            dispatch(getAbonementListClubItems({ AbonementClubId: abonementCostInfo.id }))
            setIsOpenDeleteModal(false)
        })
    }

    useEffect(() => {
        isOpenEditServices && dispatch(getServices())
    }, [isOpenEditServices])

    return (
        <>
            <AddNewAbonementServices
                visible={isOpenModalServ}
                setVisible={setIsOpenModalServ}
                abonementCostInfo={abonementCostInfo}
            />
            <EditNewAbonementServices
                visible={isOpenEditServices}
                setVisible={setIsOpenEditServices}
                abonementCostInfo={abonementCostInfo}
                abonementServicesInfo={abonementSostavInfo}
            />
            <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            />
            {abonementClubsItems?.data?.value?.rows.map(element => {
                return (
                    <Card
                        loading={abonementClubsItemsLoading}
                        title={`Состав пакета №: ${element.id}`}
                        extra={<Dropdown
                            menu={{
                                items,
                            }}
                        >
                            <a onClick={() => { setAbonementSostavInfo(element) }} className="text-primary text-decoration-none">
                                Действия <DownOutlined />
                            </a>
                        </Dropdown>}
                        style={{ width: 330, marginTop: 16 }}
                        key={element.id}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div>
                                <div>№:</div>
                                <div>Наименование:</div>
                                <div>Услуга:</div>
                                <div>Кол-во тренировок:</div>
                            </div>
                            <div>
                                <div>{element?.id ? element?.id : '-'}</div>
                                <div>{element?.itemName ? <Tooltip title={element?.itemName}>{element?.itemName.slice(0, 15)}</Tooltip> : '-'}</div>
                                <div>{element?.serviceName ? <Tooltip title={element?.serviceName}>{element?.serviceName.slice(0, 15)}</Tooltip> : '-'}</div>
                                <div>{element?.trainingsCount ? element?.trainingsCount : '-'}</div>
                            </div>
                        </div>
                    </Card>
                )
            })}
            <FloatButton
                disabled={(!mnemo?.children?.find(el => el.name === 'Состав пакета')?.children.find(ele => ele.mnemo === 'insertBtn'))}
                style={{ right: 24 }}
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                    setIsOpenModalServ(true)
                }}
            />
        </>
    )
}

export default MobileAbonementsSostav